export enum PersonNameType {
    Alias = 1,
    Alternate = 2,
    Maiden = 3,
    Nickname = 4,
    PreviouslyKnownAs = 5,
    StreetName = 6,
    NameHistory = 7
}